import GalleryBody from "./GalleryBody";

const MainGallery = () => {
  return (
    <div id="main-wrapper" className="show menu-toggle">
      <GalleryBody />
    </div>
  );
};
export default MainGallery;
